import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { logoRoutesMap } from './logoRoutesMap'

const AppLogoEmpresa = Loadable(lazy(() => import('./view/listado/logoEmpresa')))

const logoRoutes = [
  {
    path: logoRoutesMap.gestion.path,
    element: <AppLogoEmpresa />,
    auth: authRoles.admin,
  },
]

export default logoRoutes
